import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const MenuWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  background-color: #607afc;
  height: 100vh;

  .navigation-and-logo-container{
    display: flex;
    flex-direction: column;
    align-items: center;

    .logo-container{
      margin: 40px 0;
      img {
        width: 38px;
        height: 38px;
      }
    }
    
    .navigation-container{
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 15px;
      overflow: auto;
      max-height: calc(100vh - 290px);
      width: 100%;
    }
  }

  .footer-container{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap : 15px;
    svg {
      width: 45px;
      height: 45px;
      padding: 10px;
      fill: #ffffff;
      cursor: pointer;
    }
    .my-profile{
      min-height: 38px;
      max-height: 38px;
      min-width: 38px;
      max-width: 38px;
      margin: 0 auto;
      object-fit: cover;
      border-radius: 50%;
      cursor: pointer;
    }
  }
`

export const SVGLinkWrapper = styled(NavLink)`
  cursor: pointer;
  svg {
    width: 45px;
    height: 45px;
    padding: 10px;
    fill: #ffffff;
  }
  img {
    width: 45px;
    height: 45px;
    padding: 10px;
  }
`;

export const SubMenuIconWrapper = styled('div')`
  cursor: pointer;
  svg {
    width: 45px;
    height: 45px;
    padding: 10px;
    fill: #ffffff;
    path{
      fill: #ffffff;
    }
  }
  img {
    width: 45px;
    height: 45px;
    padding: 10px;
  }
`;

export const SubMenuWrapper = styled('div')`
    border-radius: 5px;
    box-shadow: 2px 3px 10px rgba(0, 0, 0, 0.2);
    width: 150px;
`

export const TextLink = styled(NavLink)`
    padding: 8px;
    width: 100%;
    word-break: normal;
    display: block;
    color: black;
    text-decoration: none;
    border-bottom: 1px solid rgba(0, 0, 0, .1);
`

export const StyledName = styled('p')`
    padding: 8px;
    width: 100%;
    word-break: normal;
    display: block;
    color: black;
    text-decoration: none;
    border-bottom: 1px solid rgba(0, 0, 0, .1);
`